import {http_client} from "@/plugins/http_client";

const url = '/api/v1/contratacion'
const urldocumentos = 'api/v1/documentos'

const contratacion = async (params = {}) => await http_client(`${url}/asignar-establecimiento-proceso`, params, 'post')
const getcontrataciones = async (params = {}) => await http_client(`${url}/establecimiento-proceso-contratacion`, params, 'get')
const updateContratacion = async (params = {}, id) => await http_client(`${url}/asignar-establecimiento-proceso/${id}`, params, 'put')
const getcontratacionById = async (id, params = {}) => await http_client(`${url}/establecimiento-proceso-contratacion/${id}`, params, 'get')
const deleteContratacion = async (id, params = {}) => await http_client(`${url}/asignar-establecimiento-proceso/${id}`, params, 'delete')
const generarDocumentos = async (params = {}) => await http_client(`${url}/documento/generador`, params, 'post')
const GetDocumentoById = async (id,id2,params = {}) => await http_client(`${urldocumentos}/contratacion/${id}/tipo/${id2}`,params,'get' )
const CargarDocumento = async (id_contratacion, params = {}) => await http_client(`${url}/documento/${id_contratacion}`,params,'post', { 'Content-Type': 'multipart/form-data' })
const descargarDocumento = async (id_contratacion, id_tipo_documento, params = {}) => await http_client(`${urldocumentos}/contratacion/${id_contratacion}/tipo/${id_tipo_documento}`,params,'get')
const enviarAFirmar = async (id_contratacion, params = {}) => await http_client(`${url}/${id_contratacion}/firma`,params,'post')
const descargarPlantillas = async (params = {}) => await http_client(`${url}/documento/previsualizar/sustituido`, params, "get");
export default {
  contratacion,
  getcontrataciones,
  updateContratacion,
  getcontratacionById,
  deleteContratacion,
  generarDocumentos,
  GetDocumentoById,
  CargarDocumento,
  descargarDocumento,
  enviarAFirmar,
  descargarPlantillas,
};
